// extracted by mini-css-extract-plugin
module.exports = {"textbox":"Textbox_textbox__2PWUA"};